const getRuntimeValues = (): Record<string, string | undefined> => {
	const cfg = typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ : undefined;
	if (!cfg) return {};

	const result: Record<string, string | undefined> = {};
	for (const key in cfg)
		if (Object.hasOwn(cfg, key)) {
			const raw = cfg[key];
			if (raw == null) result[key] = undefined;
			else {
				const value = String(raw).trim();
				result[key] = value.length > 0 ? value : undefined;
			}
		}

	return result;
};

const parseRuntimeBoolean = (value: string | undefined): boolean => {
	const normalizedValue = String(value ?? "")
		.trim()
		.toLowerCase();
	return normalizedValue === "true";
};

const runtimeValues = getRuntimeValues();

export const DEFAULT_GROUP_ID = runtimeValues.groupId;
export const DEFAULT_BUSINESS_PIC = runtimeValues.businessPic ?? "";
export const SPACE_BYPASS_2FA = parseRuntimeBoolean(runtimeValues.spaceBypass);
export const LOGIN_UNIFICADO = parseRuntimeBoolean(runtimeValues.login_unificado);
